module.exports = __webpack_public_path__ + "img/lookbook_9_left.a6527886.png";